import React, {Component} from "react";
import BarTitle from "../../components/BarTitle";
import Painel from "../../components/Painel";
import axios from "axios";
import constants from "../../constants";
import './style.css';
import * as XLSX from "xlsx";


class Establishment extends Component
{
    isSuperUser = false;
    baseUrl = '';
    totalAmountFidelity = 0;

    constructor(props) {
        super(props);
        this.state = {
            establishments: [],
            totalAmountFidelity: 0
        };
        this.baseUrl = constants().URL_API;
        this.getMerchants = this.getMerchants.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
    }

    componentDidMount()
    {
       this.getMerchants();
    }

    currencyFormat(num)
    {
        num = Number(num);
        return 'R$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    formatDate(date)
    {
        const _date = new Date(date);
        return _date.toLocaleDateString() + ' ' + _date.toLocaleTimeString();
    }

    async getMerchants()
    {
        let total = 0;
        axios.get(this.baseUrl+'/merchants')
            .then(response => {
                const data = response.data;
                if (data.code === 1)
                {
                    if (data.details.merchants)
                    {
                        const merchants = data.details.merchants;
                        for(let merchant of merchants)
                        {
                            total+= Number(merchant.amount_fidelity);
                        }
                    }
                    this.setState({establishments: data.details.merchants ? data.details.merchants : []})
                    this.setState({totalAmountFidelity: data.details.totalAmountFidelity ? data.details.totalAmountFidelity : 0})
                }
            })
    }


    convertValue(_value)
    {
        if(_value)
        {
            let value = Number(_value).toFixed(2);
            return parseFloat(value);
        }
        return 0;
        //return parseFloat(_value).toFixed(2).replaceAll('.', ',');
    }

    convertDateTime(_value)
    {
        if (_value)
        {
            let valueSplit = _value.split(' ');
            let date = valueSplit[0];
            let hour = valueSplit[1];

            return date.split('-').reverse().join('/') + '-' + hour;
        }
        return '';

    }

    convertDateToExcel(_value)
    {
        let valueSplit = _value.split(' ');
        let date = valueSplit[0];

        return date.split('-').reverse().join('-');
    }

    async exportToExcel()
    {
        this.setState({loadingSearch: true})
        let data = [];
        for(let item of this.state.establishments)
        {
            let dataToPush = {
                'ID': item.id,
                'Nome': item.name,
                'Email' :  item.email,
                'Data do último depósito': this.convertDateTime(item.deposit_datetime),
                'Data Cadastro': this.convertDateTime(item.createDatetime),
                'Status': item.is_active ? 'Ativado' : 'Desativado',
                'Valor Depósito Fidelidade': this.convertValue(item.default_amount_fidelity),
                'Valor Fidelidade': this.convertValue(item.amount_fidelity),
            };
            data.push(dataToPush);
        }
        let dataToPush = {
            'ID': '',
            'Nome': '',
            'Email' : '',
            'Data do último depósito':'',
            'Data Cadastro': '',
            'Status': '',
            'Valor Depósito Fidelidade': 'TOTAL FIDELIDADE',
            'Valor Fidelidade': this.convertValue(this.state.totalAmountFidelity),
        };

        data.push(dataToPush)
        let workSheet = XLSX.utils.json_to_sheet(data);
        let workBook = XLSX.utils.book_new();
        let name = "Relatório Estabelecimentos";
        XLSX.utils.book_append_sheet(workBook, workSheet, name);
        XLSX.writeFile(workBook, name+".xlsx", { compression: true })
        this.setState({loadingSearch: false})
    }

    render() {
        return (
            <div>
                <BarTitle name={"Estabelecimentos"}></BarTitle>
                <div className="wrapper-md">

                    <Painel title="Estabelecimentos">
                        <div className="row py-3">
                            <div className="col-md-6 h3 border-bottom pb-1">Total Saldo Fidelidade: {this.currencyFormat(this.state.totalAmountFidelity)}</div>
                            <div className="col-md-6">
                                <button className="btn btn-primary" onClick={this.exportToExcel}>Exportar</button>
                            </div>
                        </div>
                        <div className="">
                            <table className='table table-striped'>
                                <thead>
                                <tr>
                                    <td width='10'>#</td>
                                    <td width='30'>Nome</td>
                                    <td>Email</td>
                                    <td width='200'>Valor Deposito Fidelidade</td>
                                    <td width='200'>Valor Fidelidade</td>
                                    <td width='200'>Data de Ultimo Deposito</td>
                                    <td width='200'>Data Cadastro</td>
                                    <td width={'10'}>Status</td>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.establishments.length > 0 ? this.state.establishments.map((data, i) => (
                                            <tr key={i}>
                                                <td>{data.id}</td>
                                                <td>{data.name}</td>
                                                <td>{data.email}</td>
                                                <td>{data.default_amount_fidelity ? data.default_amount_fidelity : '--'}</td>
                                                <td>{data.amount_fidelity ? data.amount_fidelity : '--'}</td>
                                                <td>{data.deposit_datetime ? this.formatDate(data.deposit_datetime) : '--'}</td>
                                                <td>{data.createDatetime ? this.formatDate(data.createDatetime) : '--'}</td>
                                                <td>{data.is_active ? 'Ativado' : 'Desativado'}</td>
                                            </tr>
                                        ))
                                        :
                                        (<tr>
                                            <td colSpan={8}>Não existe registros</td>
                                        </tr>)
                                }
                                </tbody>
                            </table>
                        </div>
                    </Painel>
                </div>
            </div>
        )
    }

}

export default Establishment;


// WEBPACK FOOTER //
// ./src/views/Establishment/index.js